export default __webpack_public_path__ + "static/media/Google_Play_Button.abf9a131.svg";